export const VALENCE_LIST = [1, 2, 3, 4, 5, 6];
export const THRESHOLD_LIST = [[1.0, -1], [0.9, 1.0], [-1, 0.5], [-1, 0.4], [-1, 0.4], [-1, 0.4]]
